import { FaBullseye, FaDollarSign, FaMoneyBillWave, FaCheckCircle, FaUsers, FaSync, FaClock, FaChartLine, FaShieldAlt, FaSmile, FaRocket } from 'react-icons/fa';
import { useState, useEffect } from 'react';

function ResultsSection({ buyLink, onBuyClick }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      name: "Sumit Bhatia",
      text: "Received full payment of 1.10 lakhs for 1 year old payment, through notice and police complaint. Thanks so very much Rushneek Sir. This would not have been possible without your guidance 🙏🙏🙏"
    },
    {
      name: "Kiran Koshiya",
      text: "TOTAL RECEIVED PAYMENT 264616/- in this month 🏃 BHARAT EAK MATRA PAYMENT RECOVRY COACH, Rushneek sir 👨‍🏫😊👍 RUSHNEEK SIR JI THE 🔥🔥🔥🔥🔥"
    },
    {
      name: "Agam Rastogi",
      text: "Thank you Rushneek sir 🙏 Recovered a payment of 4.06 lacs with the help of the labour union, it was about 1.5 years old including a part which was approx 2 years old."
    },
    {
      name: "Vinit Gupta",
      text: "Recovered 6 months old payment with PRE follow-up.. Received 79,683/- Got commitment of balance 45,000/- to be cleared by next week. Thank you Rushneek Singh sir 👍"
    },
    {
      name: "Amit Gupta",
      text: "2.5 lacs out of 4 lacs only due to Notices and PRE 👌👌 Thank you Rushneek Singh sir 🙏 Almost two years old payment"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };
  const results = [

        {
      icon: <FaShieldAlt className="text-3xl sm:text-4xl text-white" />,
      label: "1. Strong control over credit  terms",
      bgClass: "from-red-900/70 to-slate-900",
      borderClass: "border-orange-500/30",
      iconBgClass: "from-orange-500 to-orange-600"
    },
     {
      icon: <FaSmile className="text-3xl sm:text-4xl text-white" />,
      label: "2. Reduced follow-up stress",
      bgClass: "from-fuchsia-900/80 to-slate-900",
      borderClass: "border-fuchsia-500/30",
      iconBgClass: "from-purple-500 to-purple-600"
    },
    {
      icon: <FaBullseye className="text-3xl sm:text-4xl text-white" />,
      label: "3. Better cash flow in business ",

      bgClass: "from-blue-900/80 to-slate-900",
      borderClass: "border-blue-500/30",
      iconBgClass: "from-blue-500 to-blue-600"
    },
 
    {
      icon: <FaMoneyBillWave className="text-3xl sm:text-4xl text-white" />,
      label: "4. Positive cash flow at all times",
      bgClass: "from-teal-900/80 to-slate-900",
      borderClass: "border-teal-500/30",
      iconBgClass: "from-teal-500 to-teal-600"
    },
    {
      icon: <FaCheckCircle className="text-3xl sm:text-4xl text-white" />,
      label: "5. Clear process to select clients who pay on time",
      bgClass: "from-purple-900/80 to-slate-900",
      borderClass: "border-purple-500/30",
      iconBgClass: "from-purple-500 to-purple-600"
    },
    {
      icon: <FaUsers className="text-3xl sm:text-4xl text-white" />,
      label: "6. Well-trained recovery team",
      bgClass: "from-orange-900/80 to-slate-900",
      borderClass: "border-orange-500/30",
      iconBgClass: "from-orange-500 to-orange-600"
    },
    {
      icon: <FaSync className="text-3xl sm:text-4xl text-white" />,
      label: "7. Defined system to recover unpaid invoices",
      bgClass: "from-pink-900/80 to-slate-900",
      borderClass: "border-pink-500/30",
      iconBgClass: "from-pink-500 to-pink-600"
    },
    {
      icon: <FaClock className="text-3xl sm:text-4xl text-white" />,
      label: "8. Customers pay on time consistently",
      bgClass: "from-yellow-900/80 to-slate-900",
      borderClass: "border-amber-500/30",
      iconBgClass: "from-amber-400 to-amber-500"
    },
    {
      icon: <FaChartLine className="text-3xl sm:text-4xl text-white" />,
      label: "9. Profit on every sale",
      bgClass: "from-red-900/80 to-slate-900",
      borderClass: "border-red-500/30",
      iconBgClass: "from-red-500 to-red-600"
    },
    {
      icon: <FaRocket className="text-3xl sm:text-4xl text-white" />,
      label: "10. More focus on sales, not chasing",
      bgClass: "from-green-900/80 to-slate-900",
      borderClass: "border-green-500/30",
      iconBgClass: "from-green-500 to-green-600"
    },

   
  ];

  return (
    <section className="relative py-24 px-4 sm:px-8 bg-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* CTA Button */}
        <div className="text-center mb-14">
          <button 
            onClick={onBuyClick}
            className="inline-block bg-gradient-to-r from-amber-400 via-amber-500 to-orange-500 text-slate-900 px-12 sm:px-20 py-4 sm:py-5 rounded-xl text-lg sm:text-2xl font-extrabold shadow-[0_10px_20px_-5px_rgba(251,191,36,0.4)] hover:shadow-[0_20px_30px_-8px_rgba(251,191,36,0.5)] hover:-translate-y-0.5 transition-all duration-200 tracking-wide cursor-pointer"
          >
            Book a call →
          </button>
        </div>

        {/* Title */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white text-center mb-4 drop-shadow-lg">
          Expected Results
        </h2>
        <p className="text-lg sm:text-xl lg:text-2xl text-slate-400 text-center mb-12 max-w-3xl mx-auto font-medium">
          What you'll achieve after completing the program
        </p>

        {/* Results Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 sm:gap-5 lg:gap-6 max-w-[1400px] mx-auto">
          {results.map((result, index) => (
            <div 
              key={index}
              className={`group relative bg-gradient-to-br ${result.bgClass} rounded-2xl p-6 sm:p-8 lg:p-10 text-center border ${result.borderClass} hover:border-opacity-60 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.4),0_8px_10px_-6px_rgba(0,0,0,0.4)] overflow-hidden`}
            >
              {/* Icon */}
              <div className={`w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 rounded-xl bg-gradient-to-br ${result.iconBgClass} flex items-center justify-center shadow-lg`}>
                {result.icon}
              </div>

              {/* Label */}
              <div className="text-base sm:text-lg lg:text-xl text-white font-bold leading-relaxed">
                {result.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ResultsSection;
